import {
    AMBULANCE_MAINTENANCE_PLATES,
    AMBULANCE_MAINTENANCE_PLATES_SUCCESS,
    AMBULANCE_MAINTENANCE_PLATES_ERROR,
    AMBULANCE_MAINTENANCE_CHASIS,
    AMBULANCE_MAINTENANCE_CHASIS_SUCCESS,
    AMBULANCE_MAINTENANCE_CHASIS_ERROR,
    AMBULANCE_MAINTENANCE_CODE_IGSS,
    AMBULANCE_MAINTENANCE_CODE_IGSS_SUCCESS,
    AMBULANCE_MAINTENANCE_CODE_IGSS_ERROR,
    AMBULANCE_MAINTENANCE_LIST,
    AMBULANCE_MAINTENANCE_LIST_SUCCESS,
    AMBULANCE_MAINTENANCE_LIST_ERROR,
    AMBULANCE_MAINTENANCE_LIST_SEARCH_CHANGE,
    AMBULANCE_MAINTENANCE_LIST_SEARCH_SET,
    AMBULANCE_MAINTENANCE_LIST_PAGE_SET,
    AMBULANCE_MAINTENANCE_DETAIL,
    AMBULANCE_MAINTENANCE_DETAIL_SUCCESS,
    AMBULANCE_MAINTENANCE_DETAIL_ERROR,
    AMBULANCE_MAINTENANCE_VIEW_MODAL_SET,
    AMBULANCE_MAINTENANCE_UPDATE_MODAL_SET,
    AMBULANCE_MAINTENANCE_UPDATE_CHANGE_SET,
    AMBULANCE_MAINTENANCE_UPDATE,
    AMBULANCE_MAINTENANCE_UPDATE_SUCCESS,
    AMBULANCE_MAINTENANCE_UPDATE_ERROR,
} from "../../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 9
        },
        data: [],
        total_pages: 0,
        first_page: 0,
        last_items: 0,
        total_item: 0
    },
    search: {
        value: {
            plate: false,
            chasis: false,
            code_igss: false
        },
        data: {}
    },
    plates: { loading: false, data: [] },
    chasis: { loading: false, data: [] },
    code_igss: { loading: false, data: [] },
    detail: {
        loading: false,
        ambulance: null,
        data: []
    },
    view: {
        modal: false
    },
    update: {
        loading: false,
        modal: false,
        data: {
            id_maintenance_detail: '',
            km_schedule: '',
            maintenance_date: null,
            km_maintenence: '',
            url_document: '',
            upload_notes: ''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case AMBULANCE_MAINTENANCE_PLATES:
            return { ...state, plates: { ...state.plates, loading: true, data: [] } };
        case AMBULANCE_MAINTENANCE_PLATES_SUCCESS:
            return { ...state, plates: { ...state.plates, loading: false, data: action.payload } };
        case AMBULANCE_MAINTENANCE_PLATES_ERROR:
            return { ...state, plates: { ...state.plates, loading: false, data: [] } };

        case AMBULANCE_MAINTENANCE_CHASIS:
            return { ...state, chasis: { ...state.chasis, loading: true, data: [] } };
        case AMBULANCE_MAINTENANCE_CHASIS_SUCCESS:
            return { ...state, chasis: { ...state.chasis, loading: false, data: action.payload } };
        case AMBULANCE_MAINTENANCE_CHASIS_ERROR:
            return { ...state, chasis: { ...state.chasis, loading: false, data: [] } };

        case AMBULANCE_MAINTENANCE_CODE_IGSS:
            return { ...state, code_igss: { ...state.code_igss, loading: true, data: [] } };
        case AMBULANCE_MAINTENANCE_CODE_IGSS_SUCCESS:
            return { ...state, code_igss: { ...state.code_igss, loading: false, data: action.payload } };
        case AMBULANCE_MAINTENANCE_CODE_IGSS_ERROR:
            return { ...state, code_igss: { ...state.code_igss, loading: false, data: [] } };

        case AMBULANCE_MAINTENANCE_LIST:
            return { ...state, loading: true };
        case AMBULANCE_MAINTENANCE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    data: action.payload.data,
                    total_pages: action.payload.total_pages,
                    first_page: action.payload.first_page,
                    last_items: action.payload.last_items,
                    total_item: action.payload.total_item
                }
            };
        case AMBULANCE_MAINTENANCE_LIST_ERROR:
            return { ...state, loading: false, list: { ...state.list, data: [] } };
        case AMBULANCE_MAINTENANCE_LIST_SEARCH_CHANGE:
            return { ...state, search: { ...state.search, value: { ...state.search.value, ...action.payload } } };
        case AMBULANCE_MAINTENANCE_LIST_SEARCH_SET:
            return { ...state, search: { ...state.search, data: { ...action.payload } } };
        case AMBULANCE_MAINTENANCE_LIST_PAGE_SET:
            return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };

        case AMBULANCE_MAINTENANCE_DETAIL:
            return { ...state, detail: { ...state.detail, loading: true, ambulance: null, data: [] } };
        case AMBULANCE_MAINTENANCE_DETAIL_SUCCESS:
            return { ...state, detail: { ...state.detail, loading: false, ambulance: action.payload.ambulance, data: action.payload.data } };
        case AMBULANCE_MAINTENANCE_DETAIL_ERROR:
            return { ...state, detail: { ...state.detail, loading: false, ambulance: null, data: [] } };

        case AMBULANCE_MAINTENANCE_VIEW_MODAL_SET:
            return { ...state, view: { ...state.view, modal: action.payload } };

        case AMBULANCE_MAINTENANCE_UPDATE_MODAL_SET:
            return { ...state, update: { ...state.update, modal: action.payload } };
        case AMBULANCE_MAINTENANCE_UPDATE_CHANGE_SET:
            return { ...state, update: { ...state.update, data: { ...state.update.data, ...action.payload } } };
        case AMBULANCE_MAINTENANCE_UPDATE:
            return { ...state, update: { ...state.update, loading: true } };
        case AMBULANCE_MAINTENANCE_UPDATE_SUCCESS:
            return {
                ...state,
                update: { ...state.update, loading: false, modal: false, data: { ...INIT_STATE.update.data } }
            };
        case AMBULANCE_MAINTENANCE_UPDATE_ERROR:
            return { ...state, update: { ...state.update, loading: false } };

        default:
            return { ...state };
    }
};
